import React, { useState, useEffect, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { GraduationCap, Search, Building2, BookOpen } from 'lucide-react';

const initialAlumniData = [
  {
    _id: "seed-1",
    name: "Dr. Nisha Bamel",
    topic: "Inter-Firm Dynamics of Joint Venture Partner: Strategic Flexibility and Joint Venture Competitiveness",
    currentPosition: "Faculty, BIMTECH",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/nisha-2.png?resize=300%2C292&ssl=1"
  },
  {
    _id: "seed-2",
    name: "Dr. Shishir Shrotriya",
    topic: "Valuation of Flexibility in the Context of an Innovation Ecosystem in India",
    currentPosition: "Commodore, Indian Navy",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/shishir.png?resize=300%2C300&ssl=1"
  },
  {
    _id: "seed-3",
    name: "Dr. Nakul Parameshwar",
    topic: "Post Termination Dynamics of Partner Firms in International Joint Ventures (IJV): Emerging Market Context",
    currentPosition: "Faculty, IIT Hyderabad",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/nakul.png?resize=200%2C300&ssl=1"
  },
  {
    _id: "seed-4",
    name: "Dr. Shiwangi Singh",
    topic: "Antecedents of Digital Innovation Implementation and its Impact on Firm Performance",
    currentPosition: "Faculty, IIM Visakhapatnam",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/shiwangi.png?resize=200%2C300&ssl=1"
  },
  {
    _id: "seed-5",
    name: "Dr. Mukesh Jain",
    topic: "Understanding The Critical Resources And Capabilities For Non Profit Organizations Serving The Individuals With Intellectual And Developmental Disabilities In India",
    currentPosition: "Senior Civil Servant, IPS officer and Visiting Faculty, Executive Education at Mahindra University",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/mukesh.png?resize=239%2C281&ssl=1"
  },
  {
    _id: "seed-6",
    name: "Dr. Ishita Batra",
    topic: "Critical Antecedents Of Performance Of International Joint Ventures In India: The Mediating Role Of Ambidexterity And Moderating Role Of Environmental Dynamism",
    currentPosition: "Faculty, FORE School of Management",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/ishita.png?resize=200%2C300&ssl=1"
  },
  {
    _id: "seed-7",
    name: "Dr. Aqueeb Sohail Shaik",
    topic: "Dynamic Impact Of Strategic Thinking, Technological Change And Risks On Firm Performance: A Select Study Of Indian Industries",
    currentPosition: "Faculty, IIM Sambalpur",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/aqueeb-shaik.png?resize=300%2C300&ssl=1"
  },
  {
    _id: "seed-8",
    name: "Dr. Shashank Shekhar",
    topic: "Developing A Revenue Model For Bioinformatic R & D In India Using Management Approach",
    currentPosition: "Indian Biological Data Centre",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/shashank-shekhar-1.jpg?resize=180%2C300&ssl=1"
  },
  {
    _id: "seed-9",
    name: "Dr. Kamakshi Sharma",
    topic: "Analysing The Antecedents Of Firm Competitiveness: Mediating Role Of Strategic Innovation And Moderating Role Of Strategic Flexibility",
    currentPosition: "Faculty, IIM Jammu",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/kamakshi.png?resize=200%2C300&ssl=1"
  },
  {
    _id: "seed-10",
    name: "Dr. Abhilasha",
    topic: "Coopetition: Antecedents, Interplay and Impact on Firm Performance",
    currentPosition: "Faculty, Delhi University",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2026/01/image-2-2.png?resize=232%2C300&ssl=1"
  },
  {
    _id: "seed-11",
    name: "Dr. Jan E Alam",
    topic: "Factors Affecting Higher Education Demand In India",
    currentPosition: "Chief Secretary of Nagaland",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2026/01/image-1.png?resize=300%2C285&ssl=1"
  },
  {
    _id: "seed-12",
    name: "Dr. Rishabh Rajan",
    topic: "Exploring Critical Success Factors Affecting Post-Acquisition Performance After Alliance Termination",
    currentPosition: "Faculty, Chandragupt Institute of Management Patna",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/rishabh.png?resize=300%2C300&ssl=1"
  },
  {
    _id: "seed-13",
    name: "Dr. Mansi Singh",
    topic: "Entrepreneurial resourcefulness and firm performance : Mediating role of bootstraping and bricolage",
    currentPosition: "Jindal Global Business School, O.P. Jindal Global University",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/mansi-1.png?resize=200%2C300&ssl=1"
  },
  {
    _id: "seed-14",
    name: "Dr. Harchitwan Kaur Lamba",
    topic: "Antecedents of firm performance in the sharing Economy : The Mediating role of entrepreneurial orientation",
    currentPosition: "Industry Consultant",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/image-2.png?resize=268%2C300&ssl=1"
  },
  {
    _id: "seed-15",
    name: "Dr. Kumari Surabhi Singh",
    topic: "Adoption of emerging technologies and its impact on firm competitiveness: A comparative study of service and manufacturing industry",
    currentPosition: "Indian Institute of Management Bodh Gaya",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/surabhi-1.png?resize=300%2C300&ssl=1"
  },
  {
    _id: "seed-16",
    name: "Dr. Pooja",
    topic: "Exploring The Impact Of Organizational Ambidexterity On Firm Performance: An Indian Service Industry Perspective",
    currentPosition: "Jindal Global Business School, O.P. Jindal Global University",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/pooja.png?resize=300%2C300&ssl=1"
  },
  {
    _id: "seed-17",
    name: "Dr. Rubina Chakma",
    topic: "Anticidents of organizational ambidexterity and its impact on innovation performance : A study on Indian MSMEs",
    currentPosition: "Faculty, IIM Rohtak",
    imageUrl: "https://i0.wp.com/sanjaydhir.com/wp-content/uploads/2025/12/image-3.png?resize=300%2C300&ssl=1"
  }
];

export default function DoctoralScholars() {
  const [scholars, setScholars] = useState(initialAlumniData);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    let isMounted = true;
    fetch('https://sanjaydhir.com/api/alumni-scholars')
      .then((res) => {
        if (!res.ok) throw new Error('API offline');
        return res.json();
      })
      .then((data) => {
        if (isMounted && Array.isArray(data) && data.length > 0) {
          setScholars(data);
        }
      })
      .catch((err) => {
        console.warn('Backend alumni route not reachable, displaying baseline data:', err);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const filtered = useMemo(() => {
    return scholars.filter((s) => {
      const q = searchTerm.toLowerCase();
      return (
        (s.name && s.name.toLowerCase().includes(q)) ||
        (s.topic && s.topic.toLowerCase().includes(q)) ||
        (s.currentPosition && s.currentPosition.toLowerCase().includes(q))
      );
    });
  }, [scholars, searchTerm]);

  return (
    <div className="container py-5 min-vh-100 position-relative text-light" style={{ zIndex: 1 }}>
      
      {/* 1. Header Banner */}
      <div className="row align-items-center g-4 mb-5">
        <div className="col-12 col-lg-8" data-aos="fade-right">
          <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-3 sub-badge">
            <GraduationCap size={16} className="text-cyan" />
            <span className="small text-light fw-medium">Alumni & Faculty Placements</span>
          </div>

          <h1 className="display-5 fw-bold text-white mb-3">
            Doctoral <span className="text-gradient">Scholars & Alumni</span>
          </h1>

          <p className="lead text-secondary fs-6 mb-4 pe-lg-3">
            Doctoral scholars supervised at the Department of Management Studies, IIT Delhi. 
            Alumni hold leadership positions as professors across IIMs, IITs, senior civil service appointments, and defence commands.
          </p>

          <div className="d-flex flex-wrap gap-3">
            <div className="p-3 rounded-3 glass-card-sm text-center" style={{ minWidth: '110px' }}>
              <span className="fs-4 fw-bold text-cyan">{scholars.length}</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Ph.D. Graduates</span>
            </div>
            <div className="p-3 rounded-3 glass-card-sm text-center" style={{ minWidth: '110px' }}>
              <span className="fs-4 fw-bold text-warning">IIMs & IITs</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Faculty Placements</span>
            </div>
            <div className="p-3 rounded-3 glass-card-sm text-center" style={{ minWidth: '110px' }}>
              <span className="fs-4 fw-bold text-info">National Leadership</span>
              <span className="small text-secondary d-block" style={{ fontSize: '0.75rem' }}>Civil Service & Defence</span>
            </div>
          </div>
        </div>

        {/* Search Input Bar */}
        <div className="col-12 col-lg-4" data-aos="fade-left">
          <div className="position-relative">
            <Search size={18} className="text-secondary position-absolute top-50 start-0 translate-middle-y ms-3" />
            <input
              type="text"
              placeholder="Search by scholar, institution, or thesis..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="form-control rounded-pill ps-5 bg-dark text-light border border-secondary border-opacity-50 py-2 small"
            />
          </div>
        </div>
      </div>

      {/* 2. Responsive Cards Grid */}
      <div className="row g-4">
        {filtered.length === 0 ? (
          <div className="col-12 text-center py-5">
            <p className="text-secondary fs-5 mb-0">No doctoral scholars found matching your search.</p>
          </div>
        ) : (
          <AnimatePresence>
            {filtered.map((item, idx) => (
              <motion.div
                layout
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.25, delay: idx * 0.03 }}
                key={item._id || idx}
                className="col-12 col-md-6 col-lg-4"
              >
                <div 
                  className="p-4 rounded-4 glass-panel h-100 d-flex flex-column justify-content-between position-relative overflow-hidden"
                  style={{
                    borderLeft: '4px solid #00f2fe'
                  }}
                >
                  <div>
                    {/* Circular Avatar */}
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div 
                        className="rounded-circle overflow-hidden flex-shrink-0"
                        style={{
                          width: '74px',
                          height: '74px',
                          border: '2px solid #00f2fe',
                          boxShadow: '0 0 12px rgba(0, 242, 254, 0.35)',
                          backgroundColor: '#0a0f1d'
                        }}
                      >
                        <img 
                          src={item.imageUrl} 
                          alt={item.name} 
                          className="w-100 h-100" 
                          style={{ objectFit: 'cover', display: 'block' }}
                          onError={(e) => {
                            e.target.src = `https://ui-avatars.com/api/?background=0D8ABC&color=fff&name=${encodeURIComponent(item.name)}`;
                          }}
                        />
                      </div>

                      <div>
                        <h5 className="fw-bold text-white mb-1" style={{ fontSize: '1.15rem' }}>
                          {item.name}
                        </h5>
                        <span 
                          className="badge px-2 py-1 rounded-pill small" 
                          style={{ background: 'rgba(0, 242, 254, 0.1)', color: '#00f2fe', border: '1px solid rgba(0, 242, 254, 0.25)' }}
                        >
                          Ph.D., IIT Delhi
                        </span>
                      </div>
                    </div>

                    {/* Doctoral Thesis Title */}
                    {item.topic && (
                      <div className="mb-3">
                        <span className="small text-secondary fw-semibold text-uppercase d-block" style={{ fontSize: '0.72rem', letterSpacing: '0.05em' }}>
                          Doctoral Thesis
                        </span>
                        <p className="text-light fw-medium small mb-0 lh-base">
                          "{item.topic}"
                        </p>
                      </div>
                    )}
                  </div>

                  {/* Current Placement / Affiliation */}
                  {item.currentPosition && (
                    <div className="pt-3 mt-2 border-top border-secondary border-opacity-15 d-flex align-items-center gap-2">
                      <Building2 size={15} className="text-warning flex-shrink-0" />
                      <span className="text-secondary small fw-medium" style={{ fontSize: '0.8rem' }}>
                        {item.currentPosition}
                      </span>
                    </div>
                  )}
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        )}
      </div>

    </div>
  );
}